import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  HostListener,
} from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { SubmitButtonShared } from '../shared/submit-button-shared';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-submit-button',
  templateUrl: './submit-button.component.html',
  styleUrls: ['./submit-button.component.scss'],
  animations: [
    trigger('upDown', [
      state('up', style({ bottom: '24px' })),
      state('down', style({ bottom: '-80px' })),
    ]),
  ],
})
export class SubmitButtonComponent implements OnInit, OnDestroy {
  @Input() title = '';
  @Input() Redesign: boolean = false;

  element: any;
  isActive = false;
  show = true;

  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;

  constructor(private submitButtonShared: SubmitButtonShared) {
    this.subscription1 =
      this.submitButtonShared.activateNextButtonObs$.subscribe((active) => {
        if (active) {
          this.isActive = true;
        } else {
          this.isActive = false;
        }
      });

    this.subscription2 = this.submitButtonShared.animateUpButtonObs$.subscribe(
      (up) => {
        if (up) {
          this.upAnimation();
        }
      }
    );

    this.subscription3 =
      this.submitButtonShared.animateDownButtonObs$.subscribe((down) => {
        if (down) {
          this.downAnimation();
        }
      });
  }

  ngOnInit() {}

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
  }

  clickAnimation() {
    this.element.style.width = 'calc( 100% - 56px )';
    this.element.style.right = '28px';
    this.element.style.height = '48px';
    this.element.style.bottom = '28px';
    setTimeout(() => {
      this.element.style.width = 'calc( 100% - 48px )';
      this.element.style.right = '24px';
      this.element.style.height = '56px';
      this.element.style.bottom = '24px';
    }, 100);
  }

  upAnimation() {
    setTimeout(() => {
      this.show = true;
    }, 300);
  }

  downAnimation() {
    setTimeout(() => {
      this.show = false;
    }, 300);
  }

  buttonClicked(e) {
    if (this.isActive) {
      this.element =
        e.srcElement.id === 'submit-button'
          ? e.srcElement
          : e.srcElement.parentElement;
      this.clickAnimation();
      this.submitButtonShared.nextButtonClicked();
    }
  }
}
